import React, { Component } from 'react'
import { connect } from 'react-redux'


class Testing3DSIntegration extends Component {
    render() {
        if(this.props.mode === 'integration_guide') {
            return (
                <div className="stepPageContainer">
                    <span className="stepPageTitle"><b>Testing 3-D Secure 2.2 Integration</b></span>
                    <div style={{marginTop: '5vh'}}>
                        <p>In the testing stage of development:</p>
                        <ol>
                            <li style={{ marginTop: '4vh'}}>Use the testing URL as Host for your requests: <b>esqa.moneris.com</b></li>
                            <li style={{ marginTop: '4vh'}}>In all <b>CardLookUp</b> requests, make sure that you are using the testing version of your credentials for <b>store ID</b> and <b>API token</b>.</li>
                            <li style={{ marginTop: '4vh'}}>In all <b>threeDSAuthentication</b> requests, make sure that you are using the testing version of your credentials for <b>store ID</b> and <b>API token</b>.</li>
                            <li style={{ marginTop: '4vh'}}>In all <b>CavvLookup</b> requests, make sure that you are using the testing version of your credentials for <b>store ID</b> and <b>API token</b>.</li>
                        </ol>
                    </div>
                </div>
            )
        }
        else {
            return null
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    return { mode };
}

export default connect(mapStateToProps, {})(Testing3DSIntegration)